
export function eventDefaultData() {  
  return {
    _id: 0,
    name: '',
    description: '',
    type: '',
    category: '',
    maxMember: '',
    mood: '',
    privacyOption: '',
    from: '',
    to: '' ,
    hideAddress: false,
    location: { main_text: '' },
    coverPic: {},
    participantsFilter: { minAge: '', gender: '' },
  }
}